export default "__VITE_ASSET__Bj8MFF90__"